// features/main/components/CreateModal.tsx
import { Modal } from '../ui/neitral.ui/modal';
import { Button } from '../ui/neitral.ui/button';
import { useNavigate } from 'react-router-dom';

interface CreateModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateModal: React.FC<CreateModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal open={open} onClose={onClose}>
      <h2 className="text-lg font-bold text-tg-text mb-4">Давай создавать</h2>
      <div className="flex flex-col gap-2">
        <Button variant="secondary" onClick={() => { navigate('/chat'); onClose(); }}>
          Универсальный чат
        </Button>
        <Button variant="secondary" onClick={() => { navigate('/pinterest'); onClose(); }}>
          Пинтрест от Кабко
        </Button>
        <Button variant="secondary" disabled>
          В разработке
        </Button>
      </div>
    </Modal>
  );
};